var $4742231a685fa068$exports = {};
$4742231a685fa068$exports = {
  "alpha": "Alfa",
  "black": "crno",
  "blue": "Plava",
  "blue purple": "plavo ljubi\u010Dasta",
  "brightness": "Svjetlina",
  "brown": "sme\u0111a",
  "brown yellow": "sme\u0111e \u017Euta",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cijan",
  "cyan blue": "cijan plava",
  "dark": "tamno",
  "gray": "siva",
  "grayish": "sivkasto",
  "green": "Zelena",
  "green cyan": "zelena cijan",
  "hue": "Nijansa",
  "light": "svjetlo",
  "lightness": "Osvijetljenost",
  "magenta": "magenta",
  "magenta pink": "magentno ru\u017Ei\u010Dasta",
  "orange": "naran\u010Dasta",
  "orange yellow": "naran\u010Dasto \u017Euta",
  "pale": "blijeda",
  "pink": "ru\u017Ei\u010Dasta",
  "pink red": "ru\u017Ei\u010Dasto crvena",
  "purple": "ljubi\u010Dasta",
  "purple magenta": "ljubi\u010Dasta magenta",
  "red": "Crvena",
  "red orange": "crveno naran\u010Dasta",
  "saturation": "Zasi\u0107enost",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " prozirnosti");
  },
  "very dark": "jako tamna",
  "very light": "vrlo svijetlo",
  "vibrant": "vibrantna",
  "white": "bijela",
  "yellow": "\u017Euto",
  "yellow green": "\u017Euto zelena"
};
export { $4742231a685fa068$exports as default };